import React from 'react';
import { useRoute } from '@react-navigation/native';

import Container from '@src/components/Container';
import VisibleStatusBar from '@src/components/VisibleStatusBar';

import { Post } from './styled';
import { Props, ScreenRouteProp } from './types';

const Screen: React.FC<Props> = () => {
  const route = useRoute<ScreenRouteProp>();

  if (!route.params?.post) {
    return <Container />;
  }

  const { id, medias, content, place } = route.params.post;

  return (
    <>
      <VisibleStatusBar />
      <Container>
        <Post
          key={id}
          image={medias[0]?.source}
          description={content}
          title={place?.name}
        />
      </Container>
    </>
  );
};

Screen.displayName = 'DummyPost';

export default Screen;
